var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tiktok tiendaAsset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500,0C223.83,0,0,223.83,0,500s223.83,500,500,500,500-223.83,500-500S776.17,0,500,0ZM750.78,382.62v67.77a237.09,237.09,0,0,1-92.19-18.55,241.58,241.58,0,0,1-52.34-30.47l.39,208.4A174.58,174.58,0,0,1,554.3,734a179.07,179.07,0,0,1-99.61,49.81,174.89,174.89,0,0,1-27,2,178.78,178.78,0,0,1-109.57-37.11A168.53,168.53,0,0,1,301.37,734c-36.33-35.93-55.28-84.76-52-136.13a173.61,173.61,0,0,1,44.14-105.47,181.16,181.16,0,0,1,161.33-58.2v94.73a85.81,85.81,0,0,0-26.56-4.3c-47.07,0-85.35,38.48-84.57,85.55a84.8,84.8,0,0,0,79.88,83,86.89,86.89,0,0,0,31.25-4.1,84.54,84.54,0,0,0,58-80.08l.2-139.45V214.45h93.16a137.81,137.81,0,0,0,2.73,27,144.48,144.48,0,0,0,141.61,116h.19v25.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokWhite);
export default __webpack_public_path__ + "static/media/tiktok-white.259904e812a42fa54a0b4ad23ac47fef.svg";
export { ForwardRef as ReactComponent };